// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "6bd18f5974470764d8e8a785dd9735e320792b16/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};